export enum LogLevel {
  Fatal,
  Errors,
  Warnings,
  Notification,
  Info,
  Debug,
}

export enum LanguageEnum {
  English = 'en',
  Arabic = 'ar',
}

export enum PageDirectionEnum {
  Rtl = 'rtl',
  Ltr = 'ltr',
}

export enum WeightUnit {
  Ton = 'TONNE',
  Kilo = 'KILOGRAM',
  Gram = 'GRAM',
}

/**
 * @todo: (@hassan)
 * please merge all Shipment statuses in one enum
 */

export enum JWTTokenValidation {
  Valid = 'valid',
  NotFound = 'NotFound',
  Expired = 'Expired',
}

export enum PermissionAction {
  Add = 'ADD',
  View = 'VIEW',
  Update = 'UPDATE',
}

export enum NotificationChannel {
  Email = 'Email',
}

export enum GeneralResponse {
  DEVICE_REGISTERED_SUCCESSFULLY = 'DEVICE_REGISTERED_SUCCESSFULLY',
}

export enum URLSegment {
  Auth = 'auth/',
  User = 'user/',
  Shared = 'shared/',
  Role = 'role/',
  Customer = 'customer/',
  WhiteLabel = 'white-label/',
  Receiver = 'receiver/',
  ProductType = 'product-type/',
  Fleet = 'fleet/',
  Shipment = 'shipment/',
  TruckType = 'truck-type/',
  Driver = 'driver/',
  Truck = 'truck/',
  PermitAccess = 'permit/',
  City = 'city/',
  Contract = 'contract/',
  Brand = 'brand/',
  Elm = 'elm/',
  Vehicle = 'vehicle/',
  DriverLocation = 'driver_location/',
  Lead = 'lead/',
  Dashboard = 'dashboard/',
  ShipmentLocation = 'shipment_location/',
  Invoice = 'invoice/',
  Organization = 'organization/',
  RouteTime = 'route-time/',
  InvoiceTransportation = 'invoice-transportation/',
  MeasurementUnit = 'measurement-unit/',
  Traccar = 'traccar/',
  Trailer = 'trailer/',
  Request = 'request/',
  CustomerSupport = 'customer-support/',
  Ticket = 'ticket/',
  WCC = 'wcc/',
  Payment = 'payment/',
  Order = 'order/',
  Pallet = 'pallet/',
  ShipmentRouting = 'shipment-routing/',
  PartialInvoice = 'partial-invoice/',
  Integration = 'integration/',
  TruckAreaPreference = 'truck-area-preference/',
  Wallet = 'wallet/',
  ExternalTracking = 'external-tracking/',
  DaleelTracking = 'daleel/',
  DistributeFleets = 'distribute-fleets/',
  OnlineBooking = 'online-booking/',
  DeliveryNote = 'delivery-note/',
  Logs = 'logs',
  Announcement = 'announcement/',
  FleetSurvey = 'fleet-survey/',
  FleetBid = 'fleet-bid/',
  Bidding = 'bidding/',
  Notifications = 'notifications/',
}

export enum UserRole {
  OrganizationOwner = 'ORGANIZATION_OWNER', // business unit owner
  Customer = 'CUSTOMER', // customer
  Owner = 'OWNER', // admin
  Fleet = 'FLEET',
  Controller = 'CONTROLLER', // controller
}

export enum DefaultRoleType {
  Owner = 'OWNER',
  Customer = 'CUSTOMER',
  Driver = 'DRIVER',
  UnverifiedDriver = 'UNVERIFIED_DRIVER',
  OrganizationOwner = 'ORGANIZATION_OWNER',
  Admin = 'ADMIN',
  OperationManager = 'OPERATION_MANAGER',
  Operation = 'OPERATION',
  SalesManager = 'SALES_MANAGER',
  Sales = 'SALES',
  Supervisor = 'SUPERVISOR',
  ERPCustomer = 'ERP_CUSTOMER',
  Fleet = 'FLEET',
  Scanner = 'SCANNER',
  Fleet_B2C = 'Fleet_B2C',
  Admin_B2C = 'Admin_B2C',
  Vendor_Owner = 'VENDOR_OWNER',
}

export enum CustomerType {
  Service = 'SERVICE',
  Saas = 'SAAS',
}
